import { apiFetch } from "../../lib/utils"; // Import apiFetch for API calls

const ReviewEndPoint = "/Reviews"; // Define the endpoint for the reviews API

// Fetch all reviews from the API
const GetAllReviews = async (): Promise<any[]> => {
    try {
        const response = await apiFetch(`${ReviewEndPoint}/api/reviews/`); // Make the API call
        const reviewData = await response.json(); // Parse the response as JSON
        // console.log("Fetched review data:", reviewData); // Log the review data
        return reviewData; // Return the data
    } catch (error) {
        console.error("Failed to fetch reviews:", error);
        return []; // Return an empty array on error
    }
};


// Fetch review by ID (if needed)
const GetReviewById = async (id: number): Promise<any> => {
    try {
        const response = await apiFetch(`${ReviewEndPoint}/${id}`); // Make the API call
        const reviewData = await response.json(); // Parse the response as JSON
        return reviewData; // Return the data
    } catch (error) {
        console.error(`Failed to fetch review with ID ${id}:`, error);
        return null; // Return null on error
    }
};

// Export the API functions
export {
    GetAllReviews,
    GetReviewById,
};
